import { Injectable } from '@angular/core';
import { createAuthorizationHeader } from '../utils/headers';
import { GlobalService } from '../global.config';
import { HttpClient } from '@angular/common/http';

export class TokenLutDto{
  deviceid : string;
  username :string;
  token: string;
  language: string;
  lastTime: Date;
}
@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  selectedTab : String; 
  constructor(private _http: HttpClient, private globalService:GlobalService) {
    this.selectedTab = "realtime";
   }

}
